import { ThunderboltOutlined, DatabaseOutlined, BranchesOutlined, PlayCircleOutlined, SettingOutlined, SyncOutlined, } from '@ant-design/icons';
import i18n from '../../../../../i18n';
// `name` getters are lazy so translations resolve at render time, not module load
export const SCENARIO_THEME = {
    general: {
        color: '#595959',
        icon: SettingOutlined,
        get name() { return i18n.t('scenarioThemeGeneral', 'General'); }
    },
    triggers: {
        color: '#1890ff',
        icon: ThunderboltOutlined,
        get name() { return i18n.t('scenarioThemeTriggers', 'Trigger Events'); }
    },
    loadersPreCondition: {
        color: '#13c2c2',
        icon: DatabaseOutlined,
        get name() { return i18n.t('scenarioThemeLoadersPreCondition', 'Data Loaders (Before Conditions)'); }
    },
    conditions: {
        color: '#52c41a',
        icon: BranchesOutlined,
        get name() { return i18n.t('scenarioThemeConditions', 'Conditions'); }
    },
    loadersPostCondition: {
        color: '#eb2f96',
        icon: DatabaseOutlined,
        get name() { return i18n.t('scenarioThemeLoadersPostCondition', 'Data Loaders (After Conditions)'); }
    },
    actions: {
        color: '#722ed1',
        icon: PlayCircleOutlined,
        get name() { return i18n.t('scenarioThemeActions', 'Actions'); }
    },
    loops: {
        color: '#fa8c16',
        icon: SyncOutlined,
        get name() { return i18n.t('scenarioThemeLoops', 'Loops'); }
    }
};
export const SCENARIO_STYLES = {
    sectionTitle: {
        fontSize: '18px',
        fontWeight: 600,
        margin: '0 0 16px 0'
    },
    cardWithTheme: (color) => ({
        borderColor: color,
        borderWidth: '2px'
    }),
    titleWithIcon: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    }
};
